<template>
    <page img="contacto" alt="Contacto" itemscope itemtype="https://schema.org/ContactPage">
        <b-overlay
            :show="isLoading"
            class="{ 'd-none': !isLoading }"
            :class="{ 'position-absolute': isLoading }"
            style="left: 0; top: 0; right: 0; bottom: 0; z-index: 9999"
            fixed
        ></b-overlay>

        <responsive-text
            text="Contáctanos"
            :left="{
                916: '8%',
                34: '10%',
                43: '10%',
                169: '10%',
            }"
            :top="{
                916: '12%',
                34: '40%',
                43: '36%',
                169: '30%',
            }"
            title
        />

        <b-container class="p-0" fluid="lg">
            <b-form ref="form" @submit.prevent="sendMail" action="#contacto" method="POST">
                <!-- Name -->
                <b-input-group size="lg mt-3" style="transition-delay: 0.1s" class="slide-bottom" v-in-viewport.once>
                    <template v-slot:prepend>
                        <b-input-group-text
                            is="label"
                            class="input-group-text"
                            for="name"
                            :class="{
                                success: validName,
                            }"
                            @click="$refs.name.focus()"
                        >
                            Nombre
                        </b-input-group-text>
                    </template>
                    <b-form-input
                        :state="validName"
                        @keyup.enter="$refs.company.focus()"
                        autofocus="autofocus"
                        id="name"
                        name="name"
                        ref="name"
                        required
                        size="lg"
                        type="text"
                        v-model="name"
                    />
                </b-input-group>

                <!-- Company -->
                <b-input-group size="lg mt-3" style="transition-delay: 0.2s" class="slide-bottom" v-in-viewport.once>
                    <template v-slot:prepend>
                        <b-input-group-text
                            is="label"
                            class="input-group-text"
                            for="company"
                            :class="{
                                success: validCompany,
                            }"
                            @click="$refs.company.focus()"
                            >Empresa
                        </b-input-group-text>
                    </template>
                    <b-form-input
                        :state="validCompany"
                        @keyup.enter="$refs.email.focus()"
                        id="company"
                        name="company"
                        ref="company"
                        required
                        size="lg"
                        type="text"
                        v-model="company"
                    />
                </b-input-group>

                <!-- Email -->
                <b-input-group size="lg mt-3" style="transition-delay: 0.35s" class="slide-bottom" v-in-viewport.once>
                    <template v-slot:prepend>
                        <b-input-group-text
                            is="label"
                            class="input-group-text"
                            for="email"
                            :class="{
                                success: validEmail,
                            }"
                            @click="$refs.email.focus()"
                            >Email
                        </b-input-group-text>
                    </template>
                    <b-form-input
                        :state="validEmail"
                        @keyup.enter="$refs.text.focus()"
                        id="email"
                        name="email"
                        ref="email"
                        required
                        size="lg"
                        type="email"
                        v-model="email"
                    />
                </b-input-group>

                <!-- Text -->
                <b-input-group size="lg mt-3" style="transition-delay: 0.5s" class="slide-bottom" v-in-viewport.once>
                    <template v-slot:prepend>
                        <b-input-group-text
                            is="label"
                            class="input-group-text"
                            for="text"
                            :class="{
                                success: validText,
                            }"
                            @click="$refs.text.focus()"
                            >Consulta
                        </b-input-group-text>
                    </template>
                    <b-form-textarea
                        :state="validText"
                        id="text"
                        name="text"
                        placeholder="¿En qué podemos ayudar?"
                        ref="text"
                        required
                        rows="5"
                        v-model="text"
                    />
                </b-input-group>

                <b-button
                    ref="submit"
                    :disabled="!validForm"
                    :variant="validForm && 'success'"
                    size="lg mt-3"
                    style="transition-delay: 0.65s"
                    type="submit"
                    class="fade-in"
                    v-b-visible="inViewport"
                >
                    <b-icon icon="envelope" />
                    Enviar
                </b-button>
            </b-form>

            <!-- Map main -->
            <div
                class="map mt-5 text-center fade-in"
                style="transition-delay: 0.3s"
                v-in-viewport="{ margin: '-50px 0px' }"
            >
                <h2>
                    Visítanos
                    <span style="white-space: nowrap"> en nuestra sede </span>
                    en Loja
                </h2>
                <iframe
                    ref="map"
                    class="d-block ml-auto mr-auto mb-5 w-75 border-0"
                    style="max-height: 40vh"
                    :src="mapsUrlPrimaryEmbed"
                    allowfullscreen=""
                    aria-hidden="false"
                    tabindex="0"
                    title="Mapa de la sede principal en Loja"
                    v-b-visible="mapHeight"
                />
            </div>

            <!-- Map branch -->
            <div
                class="map mt-5 text-center fade-in"
                style="transition-delay: 0.3s"
                v-in-viewport="{ margin: '-50px 0px' }"
            >
                <h2>
                    Visítanos
                    <span style="white-space: nowrap"> en nuestra sucursal </span>
                    en Zamora Chinchipe
                </h2>
                <iframe
                    ref="map2"
                    class="d-block ml-auto mr-auto mb-5 w-75 border-0"
                    style="max-height: 40vh"
                    :src="mapsUrlSecondaryEmbed"
                    allowfullscreen=""
                    aria-hidden="false"
                    tabindex="0"
                    title="Mapa de la surcursal en Zamora Chinchipe"
                    v-b-visible="mapHeight2"
                />
            </div>
        </b-container>
    </page>
</template>

<script>
import Page from '@/components/elements/Page';
import ResponsiveText from '@/components/elements/ResponsiveText';

export default {
    name: 'Contacto',

    components: { Page, ResponsiveText },

    data() {
        return {
            isLoading: false,
            name: '',
            company: '',
            email: '',
            text: '',
            recaptchaKey: process.env.VUE_APP_ESTSUELCON_RECAPTCHA_KEY,
            recaptchaLoading: null,
            mapsUrlPrimaryEmbed: process.env.VUE_APP_ESTSUELCON_MAPS_URL_PRIMARY_EMBED,
            mapsUrlSecondaryEmbed: process.env.VUE_APP_ESTSUELCON_MAPS_URL_SECONDARY_EMBED,
        };
    },

    async mounted() {
        this.name = this.$refs.name.$el.value = sessionStorage.name || '';
        this.company = this.$refs.company.$el.value = sessionStorage.company || '';
        this.email = this.$refs.email.$el.value = sessionStorage.email || '';
        this.text = this.$refs.text.$el.value = sessionStorage.text || '';

        await this.recaptchaLoaded();
        this.recaptchaShow();
    },

    beforeDestroy() {
        this.recaptchaHide();
    },

    computed: {
        validName() {
            if (this.$refs.name) {
                sessionStorage.name = this.name;
            }
            return (this.name && this.$refs.name.validity.valid) || null;
        },
        validCompany() {
            if (this.$refs.company) {
                sessionStorage.company = this.company;
            }
            return (this.company && this.$refs.company.validity.valid) || null;
        },
        validEmail() {
            if (this.$refs.email) {
                sessionStorage.email = this.email;
            }
            return (this.email && this.$refs.email.validity.valid) || null;
        },
        validText() {
            if (this.$refs.text) {
                sessionStorage.text = this.text;
            }
            return (this.text && this.$refs.text.validity.valid) || null;
        },
        validForm() {
            return this.validName && this.validCompany && this.validEmail && this.validText;
        },
    },

    methods: {
        /**
         * Custom visible trigger for google map
         * @param visible Boolean
         */
        mapHeight(visible) {
            if (visible) {
                this.$refs.map.height = Math.floor(document.forms[0].clientWidth * 0.75);
            }
        },

        /**
         * Custom visible trigger for google map
         * @param visible Boolean
         */
        mapHeight2(visible) {
            if (visible) {
                this.$refs.map2.height = Math.floor(document.forms[0].clientWidth * 0.75);
            }
        },

        /**
         * Custom visible trigger for submit button
         * @param visible Boolean
         */
        inViewport(visible) {
            if (visible) {
                this.$refs.submit.classList.add('in-viewport');
                this.$refs.submit.style.setProperty('opacity', 1, 'important');
            }
        },

        async recaptchaLoaded() {
            if (window.grecaptcha) {
                return true;
            }

            if (this.recaptchaLoading !== null) {
                return this.recaptchaLoading;
            }

            this.recaptchaLoading = new Promise((resolve, reject) => {
                if (!this.recaptchaKey) {
                    reject(new Error('grecaptcha key not found.'));
                }

                const script = document.createElement('script');
                script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.recaptchaKey}&hl=es-419`;
                script.async = true;
                script.onload = () =>
                    window.grecaptcha?.enterprise?.ready
                        ? window.grecaptcha.enterprise.ready(() => resolve(true))
                        : reject(new Error('grecaptcha init failed.'));
                script.onerror = () => reject(new Error('Failed to load recaptcha script.'));
                document.head.appendChild(script);
            });

            return this.recaptchaLoading;
        },

        recaptchaShow() {
            const badge = document.querySelector('.grecaptcha-badge');

            if (badge) {
                badge.hidden = false;
            }
        },

        recaptchaHide() {
            const badge = document.querySelector('.grecaptcha-badge');

            if (badge) {
                badge.hidden = true;
            }
        },

        async sendMail() {
            this.isLoading = true;

            // Get recaptcha token
            await this.recaptchaLoaded();
            const token = await window.grecaptcha.enterprise.execute('6LdYL_EUAAAAAAHqN_yqsEpnIgawFB0JsowNumEt', {
                action: 'submit',
            });

            const form = this.$refs.form;
            const data = new FormData(form);
            data.append('token', token);

            fetch('/php/contact.php', {
                method: form.method,
                body: data,
            })
                .then((response) => response.json())
                .then((response) => {
                    const message = response.success
                        ? 'Su correo se ha enviado con éxito.'
                        : 'Su correo no se ha enviado.';

                    if (response.success) {
                        this.name = '';
                        this.company = '';
                        this.email = '';
                        this.text = '';
                    }

                    this.$bvToast.toast(message, {
                        title: response.success ? '¡Muchas gracias!' : 'Error!',
                        variant: response.success ? 'success' : 'danger',
                        autoHideDelay: 12000,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style scoped>
.input-group-text {
    justify-content: center;
    align-items: start;
    width: 6.67rem;
}

.input-group-text.success {
    color: #155724;
    background-color: rgba(212, 237, 218, 0.85);
}

.input-fade-enter-active {
    transition: opacity 0.5s, transform 0.5s;
}

.input-fade-enter {
    opacity: 0 !important;
    transform: translateY(1.25vh);
}

.form-control {
    background-size: 3rem !important;
    background-position: right 0 center !important;
    transition: background-size 0.2s ease, background-position 0.2s ease;
}

.was-validated .form-control:valid,
.form-control.is-valid {
    background-size: 1.5rem !important;
    background-position: right 0.75rem center !important;
}

.btn.disabled,
.btn:disabled {
    cursor: not-allowed;
}

.btn-success {
    transition-delay: unset !important;
    animation: bounce 0.2s ease;
}

@keyframes bounce {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
    }
}

.visit {
    color: var(--var-estsuelcon-primary);
}
</style>
